import { render, staticRenderFns } from "./OptoutsModal.vue?vue&type=template&id=e9c1a7bc&scoped=true"
import script from "./OptoutsModal.vue?vue&type=script&lang=js"
export * from "./OptoutsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c1a7bc",
  null
  
)

export default component.exports